import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { ImportWriteOffFobActions } from "store/ducks/ordersFob";

export function* importWriteOffFobRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/orders-fob/write-off`,
      postData
    );
	
    yield put(ImportWriteOffFobActions.success(responseBody));
	if (onSuccess) onSuccess(responseBody);
    notify("success", "Arquivo enviado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ImportWriteOffFobActions.failure(errorMessage));
  }
}